<div class="container-fluid">
  <div class="main-div">
    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title style="color:  #1F54A3;">{{'dmbr-bo_key' | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field>
          <mat-label>{{'Lang_key' | translate}}</mat-label>
          <select matNativeControl #langSelect (change)="changeLang(langSelect.value)" [value]="currentLang">
            <option  value="en">
              English
            </option>
            <option  value="fr">
              French
            </option>
          </select>
        </mat-form-field>
        <form class="example-form">
          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <mat-label>{{'username_key' | translate}}</mat-label>
                  <input matInput placeholder="User id" [(ngModel)]="username" name="username">
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <mat-label>{{'Password_key' | translate}}</mat-label>
                  <input matInput placeholder="Password" [(ngModel)]="password" type="password" name="password">
                </mat-form-field>
              </td>
            </tr>
          </table>
        </form>
      </mat-card-content>
      <div style="padding-left: 8px;">
      <mat-card-actions>
        <button mat-raised-button (click)="login()" color="primary">{{'Login_key' | translate}}</button>
      </mat-card-actions>
    </div>
    </mat-card>
    <div class="login-logo">
      <img src="../../../assets/icons/AP.svg" width="150px" height="150px" alt="">
    </div>
  </div>
</div>
